import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { ListarFacturasGeneradasComponent } from './listar-facturas-generadas/listar-facturas-generadas.component';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';

@Component({
  selector: 'app-rep-contabilidad',
  templateUrl: './rep-contabilidad.component.html',
  styleUrls: ['./rep-contabilidad.component.scss'],
  providers:[ListarFacturasGeneradasComponent,MessagesTitles, MessagesGeneral, MessagesStatus]
})
export class RepContabilidadComponent{

  constructor(private loginService: LoginService,
    private listadoReporte: ListarFacturasGeneradasComponent) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
    this.listadoReporte.ExportTOExcel()
   }
}
